import React from "react";
import cn from "classnames";
import Box from "../Box";
import styles from "./ItemsBlock.module.scss";
import {showTitleWithDots} from "../../../../../helpers";

interface Item {
  id: string | number;
  title: string;
  url?: string;
  menu?: [];
}

interface ItemsBlockProps {
  handleLinkClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string, target?: string, isInternalLink?: boolean) => void;
  items: Item[];
}

const ItemsBlock: React.FC<ItemsBlockProps> = ({ handleLinkClick, items }) => {
  const isLastLevel = items.some(el => !!el?.menu);

  return (
    <div className={styles.itemsBlock}>
      {isLastLevel ? (
        <div className={styles.boxWrap}>
          {items.map(item => (
            //   @ts-ignore
            <div key={item.id} className={cn(styles.itemsWrap, { [styles.isBig]: item?.menu?.length > 6 })}>
              <div className={styles.title}>
                <span>{item.title}</span>
                <div />
              </div>
              {item.menu ? (
                <Box items={item.menu} handleLinkClick={handleLinkClick} className={styles.border} />
              ) : (
                <a
                  className={styles.item}
                  itemProp="url"
                  href={item.url}
                  // @ts-ignore
                  target={item.target || "_self"}
                  onMouseEnter={e => showTitleWithDots(e, item.title, true)}
                  // @ts-ignore
                  onClick={e => handleLinkClick(e, item.url, item.target, item.isInternalLink)}
                >
                  <span itemProp="name">{item.title}</span>
                </a>
              )}
            </div>
          ))}
        </div>
      ) : (
        <Box items={items} handleLinkClick={handleLinkClick} />
      )}
    </div>
  );
};

export default ItemsBlock;
